import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key] === "status") {
        return `${key}=${parseInt(params[key])}&`;
      } else if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };
    try {
      const response = await api[method](
        `${endpoint}?${getParams("_id")}${getParams("start_date")}${getParams(
          "end_date"
        )}${getParams("status")}${getParams(
          "sort_by"
        )}sort_order=${params?.sort_order || ""}&page_size=${
          params?.page_size || "10"
        }&${getParams("search")}&page=${params?.page || 1}&${getParams(
          "length"
        )}`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err.response?.data || err.message,
      };
    }
  };

export const campaign = createApi({
  reducerPath: "campaignApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Campaign"],
  endpoints: (builder) => ({
    getCampaignListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/advertisement/campaign/list`,
      }),
      provideTags: ["Campaign"],
    }),
    getCampaignFormDataById: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `admin/advertisement/campaign/edit`,
      }),
      provideTags: ["Campaign"],
    }),
    updateCampaignListData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `admin/advertisement/campaign/update`,
      }),
      
      invalidatesTags: ["Campaign"],
    }),
    deleteCampaignData: builder.mutation({
      query: (values) => ({
        method: "delete",
        params: values,
        endpoint: `admin/advertisement/campaign/delete`,
      }),

      invalidatesTags: ["Campaign"],
    }),
    getFilterListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/filters/common-search-filters`,
      }),
    }),
    clientList: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/advertisement/client-list?search`,
      }),
    }),
    priorityList: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/advertisement/campaign/basic-data`,
      }),
    }),
    statusChange: builder.mutation({
      query: (values) => ({
        method: "post",
        params: values,
        endpoint: `/admin/advertisement/campaign/status-change`,
      }),
    }),
  }),
});

export const {
  useGetCampaignListDataQuery,
  useGetCampaignFormDataByIdQuery,
  useUpdateCampaignListDataMutation,
  useDeleteCampaignDataMutation,
  useGetFilterListDataQuery,
  useClientListQuery,
  usePriorityListQuery,
  useStatusChangeMutation,
} = campaign;
